<template>
  <SAIPageWrapper>
    <CarSearchTabs />
    <div v-if="hasPricing">
      <div class="text-weight-bold row justify-center">
        <p>We found</p>
        <p class="text-primary q-mx-xs">{{ dealersPrice.length }}</p>
        <p>dealer prices</p>
      </div>
      <p class="q-mt-md text-center">Select one to see your indicative quote</p>
      <DealerPriceCard
        :disable="disable"
        v-for="(price, index) in dealersPrice"
        :key="index"
        class="q-mt-md"
        :name="price.dealer.name"
        :price="price.price"
        @select="$emit('select:price', $event)"
      />
    </div>
    <RequestingDealerPrice v-else @close="$emit('close')" />
  </SAIPageWrapper>
</template>
<script>
import { SAIPageWrapper } from 'ecx.saigon.ui.common';

export default {
  name: 'DealerPrice',
  props: {
    disable: Boolean,
    dealersPrice: {
      type: Array,
      default: () => []
    },
    hasPricing: Boolean
  },
  components: {
    SAIPageWrapper,
    DealerPriceCard: () => import('../../molecule/dealer-price-card'),
    RequestingDealerPrice: () =>
      import('../../molecule/requesting-dealer-price'),
    CarSearchTabs: () => import('../../../widgets/car-search-tabs')
  }
};
</script>
